import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_SpanishAuthorizationToDPHI = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_SpanishAuthorizationToDPHI' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>Autorización para divulgar la información confidencial</h3></center></p>
                <p className='w-750'><center>This authorization complies with the requirements of: Section 164.508 of the HIPAA Privacy Standards <br />(45 CFR, Parts 160 and 164) and
                    Occupations Code § 159.005 - Consent for Release of Confidential Information.</center></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Nombre:</span>
                            <input type='text' id='txtNameOfClient' name='txtNameOfClient' placeholder='((Nombre del cliente))' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Domicilio:</span>
                        </td>
                    </tr>
                    <tr>

                        <td className='w-750'>
                            <input type='text' id='txtAddressStreet' name='txtAddressStreet' placeholder='(Calle y número, apartado postal, número de Rt. #)' className='add-only w-350 custom-add-only' />
                            <input type='text' id='txtAddressCity' name='txtAddressCity' placeholder='(Ciudad)' className='add-only w-150 custom-add-only' />
                            <input type='text' id='txtAddressState' name='txtAddressState' placeholder='(Estado)' className='add-only w-100 custom-add-only' />
                            <input type='text' id='txtAddressZip' name='txtAddressZip' placeholder='(Código Postal)' className='add-only w-100 custom-add-only' />

                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Yo autorizo que el aquí inscrito, proveedor de servicios de salud, abogado, consejero, escuela, etc.,:
                            </span>

                            <input type='text' id='txtMedicaidNumber' name='txtMedicaidNumber' placeholder='(Individuo, médico, hospital, clínica, abogado, consejero, escuela, etc.)' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtEntityStreet' name='txtEntityStreet' placeholder='(Calle y número, apartado postal, número de Rt. #)' className='add-only w-350 custom-add-only' />
                            <input type='text' id='txtEntityCity' name='txtEntityCity' placeholder='(Ciudad)' className='add-only w-150 custom-add-only' />
                            <input type='text' id='txtEntityState' name='txtEntityState' placeholder='(Estado)' className='add-only w-100 custom-add-only' />
                            <input type='text' id='txtEntityZip' name='txtEntityZip' placeholder='(Código Postal)' className='add-only w-100 custom-add-only' />

                        </td>
                    </tr>
                </table>

                <p className='w-750'><b><span className='eleHeader'>Que divulgue la siguiente información confidencial: </span></b></p>

                <p><input type='radio' id='rbMedicalYes' name='rbMedical' className='add-only' value='Yes' /> Sí &nbsp;
                    <input type='radio' id='rbMedicalNo' name='rbMedical' className='add-only' value='No' /> No &nbsp;

                    Información médica. Indique información específica</p>


                <p><input type='radio' id='rbHivYes' name='rbHiv' className='add-only' value='Yes' /> Sí &nbsp;
                    <input type='radio' id='rbHivNo' name='rbHiv' className='add-only' value='No' /> No &nbsp;

                    Información sobre el Virus de Inmunodeficiencia Humana (VIH). Indique información específica:</p>


                <p><input type='radio' id='rbPsychologicalYes' name='rbPsychological' className='add-only' value='Yes' /> Sí &nbsp;
                    <input type='radio' id='rbPsychologicalNo' name='rbPsychological' className='add-only' value='No' /> No &nbsp;

                    Reportes psicológicos. Indique información específica:</p>


                <p><input type='radio' id='rbSocialHistoryYes' name='rbSocialHistory' className='add-only' value='Yes' /> Sí &nbsp;
                    <input type='radio' id='rbSocialHistoryNo' name='rbSocialHistory' className='add-only' value='No' /> No &nbsp;

                    Historial social. Indique información específica: </p>


                <p><input type='radio' id='rbCaseManagementYes' name='rbCaseManagement' className='add-only' value='Yes' /> Sí &nbsp;
                    <input type='radio' id='rbCaseManagementNo' name='rbCaseManagement' className='add-only' value='No' /> No &nbsp;

                    Expediente de administración de casos. Indique información específica:</p>


                <p><input type='radio' id='rbEducationalYes' name='rbEducational' className='add-only' value='Yes' /> Sí &nbsp;
                    <input type='radio' id='rbEducationalNo' name='rbEducational' className='add-only' value='No' /> No &nbsp;

                    Plan de Educación. Indique información específica:</p>


                <p><input type='radio' id='rbOtherYes' name='rbOther' className='add-only' value='Yes' /> Sí &nbsp;
                    <input type='radio' id='rbOtherNo' name='rbOther' className='add-only' value='No' /> No &nbsp;

                    Otra información. Indique información específica:</p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> al siguiente individuo::</span>

                            <input type='text' id='txtFollowingIndividual' name='txtFollowingIndividual' placeholder='(Nombre o posición del individuo, de la organización, si acaso representa a alguna) ' className='add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtFollowingIndividualStreet' name='txtFollowingIndividualStreet' placeholder='(Calle y número, apartado postal, número de Rt. #)' className='add-only w-350 custom-add-only' />
                            <input type='text' id='txtFollowingIndividualCity' name='txtFollowingIndividualCity' placeholder='(Ciudad)' className='add-only w-150 custom-add-only' />
                            <input type='text' id='txtFollowingIndividualState' name='txtFollowingIndividualState' placeholder='(Estado)' className='add-only w-100 custom-add-only' />
                            <input type='text' id='txtFollowingIndividualZip' name='txtFollowingIndividualZip' placeholder='(Código Postal)' className='add-only w-100 custom-add-only' />

                        </td>
                    </tr>
                </table>

                <p className='w-750'>La información divulgada podría ser usada por el individuo o, por la organización que el individuo representa, para los propósitos siguientes:
                    <input type='text' id='txtInfoDisclose' name='txtInfoDisclose' className='add-only' />El presente consentimiento se terminará en el momento en que se den por terminados los servicios de administración de casos
                    o cuando yo solicito que terminen. </p>

                <p className='w-750'>Esta forma &nbsp;
                    <input type='radio' id='rbReadByMe' name='rbThisFormRead' className='add-only' value='ReadByMe' /> yo la leí&nbsp;
                    <input type='radio' id='rbReadToMe' name='rbThisFormRead' className='add-only' value='ReadToMe' /> &nbsp;
                    se me leyó y, entiendo y acepto su significado. Todas las líneas en blanco fueron llenadas, antes de que yo firmara esta forma.
                    Entiendo que tengo el derecho a no firmar este consentimiento para dar información. <br />
                    Entiendo que (1) esta consentimiento no afectará el tratamiento, el pago, la participación en el programa o la elegibilidad para beneficios y (2) cualquiera que obtenga
                    información como resultado de este consentimiento puede compartirlo con otros personas como la ley lo permita.
                </p>

                <table>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>(Firma de la persona autorizada)</td> &nbsp;&nbsp;
                        <td className='small w-200'>(Fecha)</td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>(Escriba con letra de molde o con máquina de escribir el nombre de la persona autorizada para acceder a la divulgación de la información) </td> &nbsp;&nbsp;
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>(Dirección)</td> &nbsp;&nbsp;
                        <td className='small w-200'>(Número de teléfono)</td>
                    </tr>
                </table>

                <h3 className='w-750'>NOTIFICACIÓN SOBRE PRIVACIDAD</h3>
                <p className='w-750'>Tan solo por unas cuantas excepciones, usted tiene el derecho de solicitar y de ser informado sobre la información que el Estado de
                    Texas reúne sobre usted. A usted se le debe conceder el derecho de recibir y revisar la información al requerirla. Usted también
                    tiene el derecho de pedir que la agencia estatal corrija cualquier información que se ha determinado sea incorrecta.
                    <br />(Referencia: <i>Government Code, seccións 552.021, 552.023, 559.003 y 559.004)</i>
                </p>




            </div>
        </form>

    )
}











